export function pageChangeEffect(pageTitle: string) {
  return function() {
    document.title = pageTitle;
  };
}
